/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Flex,
  Space,
  Stack,
  Switch,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobalApi } from '@Apis';
import ErrorAlert from '../../../../components/Common/ErrorAlert';
import { FlexOption } from '../../../../components/EditableList';
import { FlexList } from '../../../../components/HeaderFieldList';
import config from '../../../../config';
import {
  BlockListsItem,
  BlockListsProps,
  GlobalSettingBlockListsCategories,
} from '../../../../types/globalSetting';
import common from '../../../../utils/common';
import { PolicyTypeEnum } from '../../../Policy/utils/constants';
import SmartTooltip from '@Report/SmartTooltip';

const ApprovedHeaderFields = (props: {
  policyType: PolicyTypeEnum;
  withEditPermission: boolean;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined);
  const [enabledStatus, setEnabledStatus] = useState<boolean>(false);
  const [items, setItems] = useState<BlockListsItem>({
    senders: [],
    file256Hashes: [],
    urls: [],
    fileHashes: [],
  });
  async function switchBlockListsEnabledStatus(enabledStatus: boolean) {
    try {
      const res = await GlobalApi.switchBlockLists(
        props.policyType,
        enabledStatus
      );
      if (res.data) {
        setEnabledStatus(enabledStatus);
        const msg = enabledStatus
          ? t('globalSetting.blockLists.exchange.switch.enabled.success')
          : t('globalSetting.blockLists.exchange.switch.disabled.success');
        window.showNotification({
          titleMsg: msg,
          severity: 'success',
        });
      }
    } catch (e) {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      props.setLoading(false);
    }
  }
  const [selectedItem, setSelectedItem] =
    useState<GlobalSettingBlockListsCategories>(
      GlobalSettingBlockListsCategories.SENDERS
    );
  const height = React.useMemo(() => {
    return `${5 * 32 + 32 + 12 + 17}px`;
  }, [5]);

  const onExport = () => {
    let content = '';
    items[selectedItem].forEach(function (val) {
      content += val + '\r\n';
    });
    common.exportFile('export.txt', content, 'text/plain');
  };

  useEffect(() => {
    (async function doCall() {
      try {
        props.setLoading(true);
        const blockListsProps: BlockListsProps = (
          await GlobalApi.getBlockLists(props.policyType)
        ).data;
        setItems(blockListsProps.data);
        setEnabledStatus(blockListsProps.enabledStatus);
      } catch (e) {
        setErrorMsg(t('common.apiException.internalError'));
      } finally {
        props.setLoading(false);
      }
    })();
  }, []);
  const TYPES = [
    {
      key: GlobalSettingBlockListsCategories.SENDERS,
      value: t('globalSetting.blockLists.type.senders'),
    },
    {
      key: GlobalSettingBlockListsCategories.URLS,
      value: t('globalSetting.blockLists.type.urls'),
    },
    {
      key: GlobalSettingBlockListsCategories.FILEHASHES,
      value: t('globalSetting.blockLists.type.sha1'),
    },
    {
      key: GlobalSettingBlockListsCategories.FILE256HASHES,
      value: t('globalSetting.blockLists.type.sha256'),
    },
  ];
  return (
    <Box>
      <Box>
        {errorMsg && (
          <ErrorAlert
            errorMsg={errorMsg}
            onClose={() => setErrorMsg(undefined)}
          />
        )}
        <Flex m="16px 0px">
          <Text fontSize="lg" lineHeight="lg" color={colorStyle.color.primary}>
            {t('globalSetting.blockLists.tab.title')}
          </Text>
        </Flex>
        <Flex m="16px 0px">
          <Text
            color={colorStyle.color.secondary}
            lineHeight="lg"
            maxWidth={1000}
          >
            {t('globalSetting.blockLists.description', {
              count: config.ui.globalSettings.limitation.blockedListMaxCount,
            })}
          </Text>
        </Flex>
        <Flex m="16px 0px">
          <Text>
            <Space>{t('globalSetting.note.title')}</Space>
            <Space width="1x"></Space>
            <Space color={colorStyle.color.secondary}>
              {t('globalSetting.note.applyToAllOrganizations')}
            </Space>
          </Text>
        </Flex>
        <Flex alignItems="center" m="16px 0px">
          <Switch
            pr="1x"
            id="blockLists"
            checked={enabledStatus}
            onChange={async (e: any) => {
              await switchBlockListsEnabledStatus(e.target.checked);
            }}
            disabled={!props.withEditPermission}
          />
          <Text>{t('globalSetting.blockLists.switch.label')}</Text>
        </Flex>
        <Stack direction="row" spacing="2x" m="16px 0px">
          {TYPES.map((item, index) => {
            return (
              <Button
                key={index}
                variant={selectedItem === item.key ? 'primary' : 'default'}
                borderRadius="2rem"
                columnGap="2x"
                onClick={(e: any) => {
                  setSelectedItem(e.target.value);
                  console.log(e.target.value);
                }}
                value={item.key}
              >
                {item.value}
              </Button>
            );
          })}
        </Stack>
        <FlexList width={800} direction="column" height={height} mt={16}>
          {items[selectedItem].map((item, index) => (
            <FlexOption value={item} key={index}>
              <Text maxWidth={600}>
                <SmartTooltip>{item}</SmartTooltip>
              </Text>
            </FlexOption>
          ))}
        </FlexList>
        <FlexList width={800} height={56} mt={-1}>
          <Button variant="default" onClick={onExport}>
            {t('common.action.label.export')}
          </Button>
        </FlexList>
      </Box>
    </Box>
  );
};
export default ApprovedHeaderFields;
